<template>
  <div style="padding: 20px 100px">
    <div class="style1">税收大利好，创投圈热议！</div>

    <div class="style2">2023-08-24 15:47:30　来源: 中国基金报</div>

    <div class="style3">中国基金报记者莫琳</div>

    <div class="style4">8月22日晚间，财政部、税务总局、国家发展改革委、中国证监会四部门联合发布《关于延续
      实施创业投资企业个人合伙人所得税政策的公告》。
    </div>

    <img src="static/assets/images/msg1.png"/>
    <div class="style4">本来今年年底到期的优惠政策，提前半年发布
      利好，并延期到2027年年底。“一直悬着的心终于放下了，”不少创投人士告诉记者。在他们看来，
      这是给寒冬中的创投行业送来了政策上的温暖，为创业投资行业的持续发展提供了有力的政策支持。
    </div>

    <div class="style5">两种税收核算方式引热议</div>

    <div class="style4">就具体政策来看，优惠税收政策的内容与2019年发布的《关于创业投资企业
      个人合伙人所得税政策问题的通知》（业内称“2019年8号文”）没有变化，
      创投 企业依然有两种方式进行税收核算，即按单一投资 基金 核算或按 创投 企业年度所得整体核算
      ：
    </div>

    <div class="style4">一种是，按单一投资基金核算的，其个人合伙人在一个纳税年度从该基金应分得的 股权转让
      所得和股息红利所得，按照20%税率计算缴纳个人所得税。其中，符合条件的创投企业个人合伙人可以
      按照被转让项目对应投资额的70%抵扣其应从基金年度股权转让所得中分得的份额后再计算其应纳税额，
      当期不足抵扣的，不得向以后年度结转。
    </div>

    <div class="style4">另一种是，创投企业选择按年度所得整体核算的，其个人合伙人应从创投企业取得的所得，按照“经营
      所得”项目、5%-35%的超额累进税率计算缴纳个人所得税。“选择年度整体核算的优势在于，年度整体核
      算既可以在合伙企业层面抵扣管理费，业绩报酬等费用，还可以跨年度结转往年亏损，亏损可以结转五年，
      对于投资较多早期项目，且容易前期产生亏损项目的基金较为合适。”紫荆资本法务总监汪澍告诉记者。
    </div>

    <div class="style4">这一税收优惠政策实施三年来，大部分创投机构认为，这一税收政策在维护国家税收法定原则权威的基础上，
      按照所得性质穿透进行征税，从而把最高税率从综合所得税制的超额累进税率税负最高35%降到了分类所得
      税制的单一比例税率最高20%，从直观上看确实是一个比较大的税收优惠。
    </div>

    <div class="style4">但在实际操作过程中，以往普遍
      存在的合理避税渠道被封堵，从创投机构的角度来看，降税的实际感受没有那么强烈。据记者了解，在2019
      年8号文出台之前，按照部分地方出台的“税收优惠政策”，合伙型基金的个人合伙人可以将其按照“生产经营所
      得”分得的基金收益，按照分类所得税制的单一比例税率20%进行纳税。简单来说，就是在单一投资基金之下
      ，盈亏项目相抵消后，所得部分再按照20%来进行交税。
    </div>

    <div class="style4">而在现行的政策中，如果选择了单一投资基金核算
      的话，仅允许抵扣和交易相关的合理费用，并认定管理费和业绩报酬不属于合理费用不得抵扣。最重要的是
      ，亏损不能跨年结转。因为一般来说，好的项目会率先退出，并计提股权转让所得；投资失败的项目往往
      会拖至基金清盘之时，而根据现行的单一投资基金的核算方式，税收已经在前期缴纳完毕，后期的亏损却
      不能跨年结转。
    </div>

    <div class="style4">最重要的是，亏损不能够跨年度抵扣或者结转，这对于一些部分项目亏损发生在前，盈利
      项目退出在后的基金而言极为不利。
    </div>

    <div class="style4">汪澍指出，“税收无小事”。2019年8号文是一份全国性的税收政策文件
      ，真正从国家立法的层面去疏通合伙型基金的征税规则，破除一些地方为了刺激本地投资而推出的较为激进的
      ，和现行国家税法相悖的“税收优惠”。8号文的出台，给了地方“税收优惠”政策上的明确指引，让超出国家
      税法规定的“税收优惠”存在的合理空间收窄。同时，也刺激GP和LP之间有意识地真正去把握自身的退出节
      奏，然后选择合适的税筹方案。比如选择按照单一投资基金核算的GP，从税筹方案的角度考虑，及时为一些
      “僵尸项目”做亏损减值工作，从而实现在纳税年度内进行投资亏损的抵扣。
    </div>

    <div class="style4">安永中国税务部合伙人刘成彦也
      认为，企业应充分考虑当前基金所属阶段以及投资项目的运营情况后选择核算方式。对于备案为创投企业的
      基金其选择单一基金核算会适用更低的税率，但选择按单一基金核算的，由于其个人合伙人在核算应纳税所
      得时相较于按年度所得整体核算存在一定限制，包括不可扣除投资基金管理人的管理费和业绩报酬等基金运营费
      用，亏损不能跨年结转等，对于处于投资初期或者预期回报较低的基金，选择年度所得整体核算模式的整体税负
      在考虑扣除多项费用及亏损结转后可能优于单一基金核算方式；当然对于基金到了集中退出期阶段，管理人对于
      基金的退出路径以及预期收益比较有把握的情况下，选择按单一投资基金核算模式应该更为优惠。需要注意的是，
      创投企业选择其中一种核算方式后，3年内不能变更。
    </div>

    <div class="style5">业内期待更多、更细的优惠政策</div>

    <div class="style4">昨晚，除了延续创业投资企业
      个人合伙人所得税政策之外，8月22日发布的公告还包括《关于延续实施支持原油等货物期货市场对外开放个人
      所得税政策的公告》《关于延续实施沪港、深港股票市场交易互联互通机制和内地与香港基金互认有关个人所得税
      政策的公告》《关于延续实施上市公司股权激励有关个人所得税政策的公告》等一系列配套政策。
    </div>

    <div class="style4">财政部相关负责人
      表示，上述政策有利于支持资本市场对外开放，促进资本市场持续健康发展。下一步将会同有关部门认真组织实施，
      确保政策红利精准直达经营主体，同时有序公布其他税费优惠政策后续安排，着力为经营主体纾困解难，推动经济持
      续回升向好。
    </div>

    <div class="style4">面对最新发布的政策，业内也多期待有更多创投行业税收优惠政策。基石资本财务部副总经理许海伟表示，
      政策提前续期意味着“靴子落地了”，政策延续4年适配了私募创业投资基金投资期限长的行业特点，这也意味着创投
      行业税收将面临一定压力，希望未来对创投行业提供更大的税收支持，以为国家的创新创业和科技创新提供更好的创
      投环境。
    </div>

    <div class="style4">紫荆资本法务总监汪澍建议，能够进一步完善按照“单一投资基金核算”的征税方式。在按照所得形式穿透核
      算的基础上，允许将适用的单一比例税率与投资期限进行反向挂钩，适时推出长期投资优惠税率，如降低到10%。同时
      ，建议放松对征税方案的期限要求，以便于市场根据自身现实状况选择合理的税筹方案。
    </div>

    <div class="style4">安永中国税务部合伙人刘成
      彦提出，就创投企业税收优惠而言，目前业内希望明确多层嵌套结构下创投企业个人合伙人的个税优惠政策的适用性
      问题。在实务中多层嵌套结构比较常见，但母基金是否可以适用以上优惠政策尚未明确，仍需和地方税务机关予以沟
      通。
    </div>

    <div class="style4">从更广泛的角度来说，合伙制基金的相关税务处理与企业所得税、个人所得税原有的一些优惠政策未能明确地衔
      接，例如现行企业所得税法规定，居民企业之间分配股息免征企业所得税，但合伙制基金取得被投资企业分配股息向
      其法人股东进行分配，上述免税政策在目前的征管实践中无法适用。私募基金投资在活跃资本市场、提升经济活力方
      面发挥重要作用，业内还是期待能对合伙制基金的税务处理进行系统性明确，更好地发挥税收政策的促进作用，刘成
      彦进一步解释道。
    </div>
  </div>

</template>

<script>
export default {
  mounted () {
    // 跳转后返回页面顶部
    window.scrollTo(0, 0)
  }
}
</script>

<style>
.style1{
  font-size: 20px;
  font-weight: 600;
  line-height: 80px;
}
.style2{
  font-size: 16px;
  line-height: 30px;
}
.style3{
  font-size: 16px;
  line-height: 30px;
}
.style4{
  font-size: 17px;
  line-height: 28px;
  margin: 20px 0;
}
.style5{
  text-align: center;
  font-size: 18px;
  font-weight: 600;
  line-height: 30px;
  margin: 25px 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/msg1.vue